import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

interface SEOProps {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
  type?: string;
}

export const SEO: React.FC<SEOProps> = ({
  title,
  description,
  image = 'https://weddie.site/images/herobanner_desktop.jpg',
  url = 'https://weddie.site',
  type = 'website',
}) => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  
  const defaultTitle = t('seo.title');
  const defaultDescription = t('seo.description');
  
  const siteTitle = title || defaultTitle;
  const siteDescription = description || defaultDescription;
  
  return (
    <Helmet>
      {/* Basic metadata */}
      <html lang={currentLanguage} />
      <title>{siteTitle}</title>
      <meta name="description" content={siteDescription} />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      
      {/* Contact information */}
      <meta name="contact" content="the.weddie.site@gmail.com" />
      <meta name="telephone" content="+48 665 123 549" />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={siteTitle} />
      <meta property="og:description" content={siteDescription} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="Weddie Site" />
      <meta property="og:locale" content={currentLanguage} />
      <meta property="og:locale:alternate" content={currentLanguage === 'pl' ? 'en' : 'pl'} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={siteTitle} />
      <meta name="twitter:description" content={siteDescription} />
      <meta name="twitter:image" content={image} />
      
      {/* Keywords */}
      <meta name="keywords" content={t('seo.keywords')} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={url} />
      
      {/* Alternate language versions */}
      <link rel="alternate" hrefLang="pl" href="https://weddie.site/?lang=pl" />
      <link rel="alternate" hrefLang="en" href="https://weddie.site/?lang=en" />
      <link rel="alternate" hrefLang="x-default" href="https://weddie.site" />
    </Helmet>
  );
};
